import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import {AiOutlineClose, AiOutlineMenu} from 'react-icons/ai'

const Navbar = () => {
    const [nav, setNav] = useState(false)
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 0) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNav = () => {
        setNav(!nav)
    }
    const closeNav = () => setNav(false);

    const linkClass = ({ isActive }) =>
      `hover:underline underline-offset-8 transition p-5 ${isActive ? 'underline' : ''}`;

    return (
      <div className={`fixed top-0 left-0 w-full z-50 text-[rgb(0,58,125)] transition-all duration-300 ${scrolled ? 'backdrop-blur-md bg-white/60 shadow-md' : 'bg-white shadow-none'}`}>
        <div className='flex justify-between items-center h-24 w-full mx-auto px-4 md:px-14'>
          <img src="/logo/logo.png" alt="Logo" className="h-12 w-auto" />
          <ul className='hidden md:flex text-sm items-center gap-3 capitalize '>
              <li><NavLink to="/" className={linkClass} end>HOME</NavLink></li>
              <li><NavLink to="/about" className={linkClass}>ABOUT</NavLink></li>
              <li><NavLink to="/services" className={linkClass}>SERVICES</NavLink></li>
              <li><NavLink to="/works" className={linkClass}>WORK</NavLink></li>
              <li>
                  <NavLink to="/contact" className={({ isActive }) => `transition ${isActive ? 'underline font-bold' : ''}`}>
                    <button className='bg-[#003A7D] text-white px-4 py-3 hover:bg-[#002060] transition duration-300'>
                      CONTACT
                    </button>
                  </NavLink>
              </li>
          </ul>
          <div className='md:hidden'>
              <AiOutlineMenu size={20} onClick={handleNav} className={`${nav ? 'hidden' : 'block'}`}/>
              <AiOutlineClose size={20} onClick={handleNav} className={`${nav ? 'block' : 'hidden'}`}/>
          </div>
          <div className={
            `md:hidden z-20 fixed top-24 left-0 w-full h-[calc(100vh-6rem)] transition-all duration-500
            ${nav ? 'translate-y-0 opacity-100 pointer-events-auto' : '-translate-y-8 opacity-0 pointer-events-none'}
            backdrop-blur-md bg-white/80 border-t border-white/20`
          }>
            <ul className='flex flex-col justify-center gap-y-8 p-10 text-center text-[#003A7D] font-semibold capitalize'>
              <li><NavLink to="/" className={linkClass} end onClick={closeNav}>HOME</NavLink></li>
              <hr className="border-t border-[#003A7D]/20 w-2/3 mx-auto" />
              <li><NavLink to="/about" className={linkClass} onClick={closeNav}>ABOUT</NavLink></li>
              <hr className="border-t border-[#003A7D]/20 w-2/3 mx-auto" />
              <li><NavLink to="/services" className={linkClass} onClick={closeNav}>SERVICES</NavLink></li>
              <hr className="border-t border-[#003A7D]/20 w-2/3 mx-auto" />
              <li><NavLink to="/works" className={linkClass} onClick={closeNav}>WORK</NavLink></li>
              <hr className="border-t border-[#003A7D]/20 w-2/3 mx-auto" />
              <li><NavLink to="/contact" className={({ isActive }) => `transition ${isActive ? 'underline font-bold' : ''}`} onClick={closeNav}>CONTACT</NavLink></li>
            </ul>
          </div>
        </div>
      </div>
    )
}

export default Navbar